import { api } from '@/api'
import type { RequisitionFilters, RequisitionItem } from '@/api/typings/requisition.typing'
import type { ApiPaginationResponse } from '@/api/typings/response.typing'

export function getRequisitionsAction(
  filters: RequisitionFilters = {}
): Promise<ApiPaginationResponse<RequisitionItem[]>> {
  const params = new URLSearchParams()

  if (filters.page) {
    params.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      params.append(`filter[${key}]`, String(value))
    }
  })

  const url = `/requisitions?${params.toString()}`

  return api.get<ApiPaginationResponse<RequisitionItem[]>>(url)
}
